import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=69cfb4da&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=69cfb4da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cfb4da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69cfb4da')) {
      api.createRecord('69cfb4da', component.options)
    } else {
      api.reload('69cfb4da', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=69cfb4da&scoped=true&", function () {
      api.rerender('69cfb4da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jfjZTL3VBS3q/JS/comp/CookieBox.vue"
export default component.exports